@use '../../styling/colors.scss' as *;

.GuideModalOverlay {
  box-sizing: border-box;
  position: fixed;
  z-index: 4;

  .GuideModal {
    background: $theme-color-background;
    will-change: transform;
    outline: none;
    box-shadow: 1px 1px 3px 3px $theme-color-shadow;
    overflow: auto;
    border-radius: 4px;

    &:focus {
      outline: none;
    }
  }

  &.GuideModalContentFromBottom {
    bottom: 0;
    width: 100%;
    padding-bottom: 0;

    .GuideModal {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &.GuideModalContentFromRight {
    right: 0;
    height: 100%;
    padding-right: 0;
    top: 0;

    .GuideModal {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      height: 100%;
    }
  }
}
